import {
  Form,
  Input,
  Modal,
  Select,
  DatePicker,
  Tooltip,
  message,
} from "antd";
import React, {
  forwardRef,
  useEffect,
  useState,
  useRef,
} from "react";
import {
  MailOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";
import "./index.scss";
import moment from "moment";
import parse from 'html-react-parser';
import PDFModal from "./component/PDFModal";
import { useLocation } from "react-router-dom";
import commonFn from "@/utils/commonFn";
import ButtonList from "./component/ButtonList";
import { CustomTable, CustomTableExtend } from "@/hocComponents";

const MainTable = forwardRef((props, ref) => {
  const location = useLocation();
  const [selectedList, setSelectedList] = useState([]);
  const [openApproval, setOpenApproval] = useState(false);
  const [approvalForm] = Form.useForm();
  const [printForm] = Form.useForm();
  const [printCheckForm] = Form.useForm();
  const [onlyForm] = Form.useForm();
  const [openPrintModal, setOpenPrintModal] = useState(false);
  const [openPrintCheckModal, setOpenPrintCheckModal] = useState(false);
  const [openOnlyModal, setOpenOnlyModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [payByList, setPayByList] = useState([]);
  const [greater, setGreater] = useState([]);
  const [small, setSmall] = useState([]);

  const initTableHead = {
    trust: null,
    prop: null,
    street: null,
    numberOfUnits: null,
    name: null,
    vendid: null,
    glAcct: null,
    amount: null,
    bank:null,
    customerAccount: null,
    invoice: null,
    invoiceDate:null,
    remark:null,
    udate:null,
  }
  const [tableHead, setTableHead] = useState(initTableHead);

  const tableFilterFn = (event, key, type = 'Input') => {
    commonFn.tableFilterFn({event, key, type, setTableHead, getTableListFn})
  }

  const initColumns = [
    // {
    //   title: '#',
    //   dataIndex: '#',
    // },
    {
      title: 'Trust',
      dataIndex: "trust",
      titleType: 'Input',
      width:80,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'trust')
    },
    {
      title: 'Prop',
      dataIndex: "prop",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'prop')
    },
    {
      title: 'Address',
      dataIndex: "street",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'street')
    },
    {
      title: '#Units',
      dataIndex: "unitId",
      width:60,
      titleType: '',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'unitId'),
    },
    {
      title: 'Vendor',
      dataIndex: "vendid",
      titleType: 'Input',
      width:180,
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center",}}>
          <span>{text}</span>
          <Tooltip title={parse(record?.preCalPre || '')}>
            <MenuOutlined
              style={{ marginLeft: 8, cursor: "pointer", color: "#a94442" }}
            />
          </Tooltip>
        </div>
      ),
      onChange: e => tableFilterFn(e, 'vendid')
    },
    {
      title: 'GL-Title',
      dataIndex: "glAcct",
      titleType: 'Input',
            width:180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'glAcct'),
    },
    {
      title: 'Amount',
      dataIndex: "amount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        if (text == null || text === "") return "-";
        return (
          <span
            onClick={() => handleAmountClick(record)}
            className="CA-AS-AmountStyle"
          >
            {new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(text)}
          </span>
        );
      },
      onChange: e => tableFilterFn(e, 'amount'),
    },
    {
      title: 'Bank',
      dataIndex: "bank",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      render: (text, record) => {
        return `(${text}) ${record?.bankList?.[text] || ''}`
      },
      onChange: e => tableFilterFn(e, 'bank'),
    },
    {
      title: 'Customer #',
      dataIndex: "customerAccount",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'customerAccount'),
    },
    {
      title: 'Invoice #',
      dataIndex: "invoice",
      titleType: 'Input',
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'invoice'),
    },
    {
      title: 'Inv Date',
      dataIndex: "invoiceDate",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'invoiceDate', 'DatePicker'),
    },
    {
      title: 'Check Memo',
      dataIndex: "remark",
      titleType: 'Input',
      width: 180,
      isSorter: true,
      sortterMultiple: 3,
      onChange: e => tableFilterFn(e, 'remark'),
    },
    {
      title: 'Approval Status',
      dataIndex: "approve",
      titleType: '',
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
    },
    {
      title: "Rejected Reason",
      dataIndex: "rejectedReason",
      titleType: "Input",
      width: 150,
      isSorter: true,
      sortterMultiple: 3,
      onChange: (e) => tableFilterFn(e, 'rejectedReason'),
    },
    // {
    //   title: 'Type',
    //   dataIndex: "type",
    //   titleType: '',
    //   isSorter: true,
    //   sortterMultiple: 3,
    // },
    // {
    //   title: 'User ID',
    //   dataIndex: "usid",
    //   titleType: 'Input',
    //   isSorter: true,
    //   sortterMultiple: 3,
    //   onChange: e => tableFilterFn(e, 'usid'),
    // },
    {
      title: 'Updated Date',
      dataIndex: "udate",
      titleType: 'DatePicker',
      isSorter: false,
      onChange: (e) => tableFilterFn(e, 'udate', 'DatePicker'),
    },
  ]

  const [columns, setColumns] = useState(initColumns);
  const [refreshKey, setRefreshKey] = useState(0);
  const [tableList, setTableList] = useState([]);
  const [tableLoading, setTableLoading] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });

  // 提交数据
  const handleSubmit = async () => {
    // 验证表单
    const values = await approvalForm.validateFields();

    // 合并数据：表格选中的数据 + 表单数据
    const payload = {
      selectedData: selectedList,
      formData: values,
    };

    message.success("提交成功");
    setOpenApproval(false);
  };

  const initialValues = {
    postDate: moment().startOf("day"),
  };

  const handleDateChange = (date) => {
    return date ? date.clone() : null;
  };

  const handlePrintSubmit = () => {
    printForm.validateFields().then((values) => {
      console.log("打印数据:", {
        ...values,
        postDate: values.postDate.format("MM/DD/YYYY"),
      });

      setOpenPrintCheckModal(false);
    });
  };

  const handleDateCheckChange = (date) => {
    return date ? date.clone() : null;
  };

  const initialCheckValues = {
    postDate: moment().startOf("day"),
  };

  const initialOnlyValues = {
    postDate: moment().startOf("day"),
  };

  const handleDateOnlyChange = (date) => {
    return date ? date.clone() : null;
  };

  
  const getDictionaryFn = async(value) => {
    const params = {
        type:'util_payment',
        value
    }
    const response = await http.get(api.getDictionary, { params });
    switch (value) {
      case 'payBy':
        setPayByList(response)
        break;
      default:
        break;
    }
}

const initColunmsFn = () => {
  setSelectedList([]);
  setTableHead(initTableHead);
  setColumns(initColumns);
}

  useEffect(() => {
    getDictionaryFn('payBy')
  }, []);

  useEffect(() => {
    if(payByList.length){
      setColumns(initColumns);
    }
  }, [payByList]);

  useEffect(() => {
    initColunmsFn()
    getTableListFn(1, 25)
  }, [refreshKey])

  const PDFModalRef = useRef();

  const handleAmountClick = (record) => {
    setCurrentRecord(record);
    PDFModalRef?.current?.setModalOpen(true);
  };

  const setGreaterAndSmallFn = async(list = []) => {
    if(!list.length) return
    const ids = list.map(item => item.foreignId).join(",");
    const result = await http.get(api.ApprovalRecent, { params: { ids } });
    setGreater(result?.greater || []); 
    setSmall(result?.small || []); 
  }

  //列表
  const getTableListFn = async (current, pageSize, tableHead = {}) => {
    setTableLoading(true);
    const params = {
      page: current || pagination.current,
      count: pageSize || pagination.pageSize,
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      module: new URLSearchParams(location.search).get("module"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    };
    const response = await http.get(api.getShowApprovalBySummary, { params });
    // setSelectedList([])
    if (response?.code !== "1") {
      commonFn.modalFailedFn(response)
      setTableLoading(false);
      return
    }
    const list = (response.data.list || []).map((item, index) => ({ ...item, '#': (params.page - 1) * params.count + index + 1}));
    setGreaterAndSmallFn(list)
    setTableList(list);
    setPagination((prev) => ({
      ...prev,
      total: response.data.total || 0,
      current: params.page,
      pageSize: params.count,
    }));
    setTableLoading(false);
  };
  const handleTableChange = (pagination, filters, sorter) => {
    const { field: orderField, order: orderType, columnKey } = sorter
    if(columnKey ==='trust'){
      const tableHeadTemp = {
        ...tableHead,
        orderField,
        orderType,
      }
      getTableListFn(pagination.current, pagination.pageSize, tableHeadTemp);
    } else {
      getTableListFn(pagination.current, pagination.pageSize, tableHead);
    }
  };

  const rowSelection = {
    selectedRowKeys: selectedList.map(item => item.vendorPaymentId),
    getCheckboxProps: (record) => ({
      style: record.isEmpty ? { display: "none" } : {}, 
      disabled: record.approve === "Waiting For Approval" 
    }),
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedList(selectedRows);
    },
  };

  const downLoadFn = async () => {
    const params = {
      ...tableHead,
      email: new URLSearchParams(location.search).get("email"),
      module: new URLSearchParams(location.search).get("module"),
      transactionsType: new URLSearchParams(location.search).get("type"),
      batchGroup: new URLSearchParams(location.search).get("batchGroup"),
    }
    const blob = await http.get(api.exportApprovalBySummaryCsv, {params, responseType: 'blob'});
    return {
      blob,
      name: new URLSearchParams(location.search).get("module").charAt(0).toUpperCase() + new URLSearchParams(location.search).get("module").slice(1).toLowerCase()
    };
  };

  return (
    <div>
      <CustomTableExtend
        columns={columns}
        setColumns={setColumns}
        initColumns={initColumns}
        refreshKey={refreshKey}
        setRefreshKey={setRefreshKey}
        noShowList={[!commonFn.btnAuthorityFlag('ApprovalDownload') && 'download']}
        downLoadFn={() => downLoadFn()}
      >
        <ButtonList
          email={new URLSearchParams(location.search).get("email")}
          transactionsType={new URLSearchParams(location.search).get("type")}
          moduleType={new URLSearchParams(location.search).get("module")}
          selectedList={selectedList}
          refreshTableFn={() => setRefreshKey(+new Date())}
        />
      </CustomTableExtend>

      <CustomTable 
        refreshKey={refreshKey}
        tableLoading={tableLoading}
        rowSelection={{
          preserveSelectedRowKeys: true,
          type: "checkbox",
          ...rowSelection,
        }}
        rowClassName={(record) => {
          if(greater.includes(record.vendorPaymentId)){
            return ["greater-row"]
          }
          if(small.includes(record.vendorPaymentId)){
            return "small-row"
          }
          return [record.vendorPaymentId]
        }}
        rowKey="vendorPaymentId"
        columns={columns}
        tableList={tableList}
        pagination={pagination}
        handleTableChange={handleTableChange}
        tableScrollY="300px"
        tableCss="AS-tableClass"
      />

      {/* modal */}
      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            APPROVAL REQUEST CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openApproval}
        onCancel={() => {
          setOpenApproval(false);
          approvalForm.resetFields();
        }}
        onOk={handleSubmit}
        width="50%"
        maskClosable={false}
      >
        <Form form={approvalForm} layout="vertical">
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to request these checks to be approved?
          </div>

          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                {
                  value: "1",
                  label: "Request 1 transaction(s) to be Approved",
                },
                {
                  value: "all",
                  label: "Request All transaction(s) to be Approved",
                },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="noteForMike"
            label="Note For Mike:"
            style={{ flex: 2 }}
          >
            <Input placeholder="Enter your note here" />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            PRINT CASHIER CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openPrintModal}
        onCancel={() => {
          setOpenPrintModal(false);
          printForm.resetFields();
        }}
        onOk={handlePrintSubmit}
        width="50%"
        maskClosable={false}
      >
        <Form form={printForm} layout="vertical" initialValues={initialValues}>
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            System Limited to 500 rows of Approved Records, Please select below
            items
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Print all approved transactions" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateChange}
              disabled
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            PRINT CASHIER CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openPrintCheckModal}
        onCancel={() => {
          setOpenPrintCheckModal(false);
          printCheckForm.resetFields();
        }}
        onOk={() => setOpenPrintCheckModal(false)}
        width="50%"
        maskClosable={false}
      >
        <Form
          form={printCheckForm}
          layout="vertical"
          initialCheckValues={initialCheckValues}
        >
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to print these cashiers check(s)?
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Print All Cashier Checks" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateCheckChange}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title={
          <div style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}>
            <MailOutlined style={{ marginRight: "8px" }} />
            RECORD CHECK CONFIRMATION
            <div
              style={{ borderTop: "3px solid #3c8dbc", marginTop: "8px" }}
            ></div>
          </div>
        }
        centered
        open={openOnlyModal}
        onCancel={() => {
          setOpenOnlyModal(false);
          onlyForm.resetFields();
        }}
        onOk={() => setOpenPrintCheckModal(false)}
        width="50%"
        maskClosable={false}
      >
        <Form
          form={onlyForm}
          layout="vertical"
          initialOnlyValues={initialOnlyValues}
        >
          <div style={{ marginBottom: "16px", fontSize: "20px" }}>
            Are you sure you want to print these cashiers check(s)?
          </div>
          <Form.Item
            name="transactionCount"
            label="How Many Transactions?"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Record All Chencks" },
                // { value: "all", label: "Print all checks" }
              ]}
            />
          </Form.Item>

          <Form.Item
            name="transactionCount"
            label="Record By:"
            rules={[{ required: true }]}
            style={{ flex: 1 }}
          >
            <Select
              placeholder="Select option"
              options={[
                { value: "1", label: "Property" },
                { value: "2", label: "Transaction" },
                { value: "3", label: "Trust" },
                { value: "4", label: "Vendor Code" },
                { value: "5", label: "Invoice" },
              ]}
            />
          </Form.Item>

          <Form.Item
            name="postDate"
            label="Post Date"
            rules={[{ required: true, message: "Please select a date" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              format="MM/DD/YYYY"
              onChange={handleDateOnlyChange}
              getPopupContainer={(trigger) => trigger.parentElement}
            />
          </Form.Item>
        </Form>
      </Modal>

      <PDFModal ref={PDFModalRef} record={currentRecord} />

    </div>
  );
});
export default MainTable;
